// Leitura das respostas da IA, compartilhada entre backend e tela.
// Mesma regra do shared/clinical: funções puras, sem Sails e sem Vue.

module.exports = {
    ...require('./response')
};
